/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SetPartnerCreatorTestStatusResponse, SetPartnerCreatorTestStatusVars } from '../openapi-types.gen.js';

export type { SetPartnerCreatorTestStatusResponse, SetPartnerCreatorTestStatusVars } from '../openapi-types.gen.js';

export const useSetPartnerCreatorTestStatus = createMutationHook<SetPartnerCreatorTestStatusVars, SetPartnerCreatorTestStatusResponse, unknown>({
  specName: 'useSetPartnerCreatorTestStatus',
  path: '/v1/admin/creators/{id}/test-status',
  method: 'POST',
  resolveUrl: (vars: SetPartnerCreatorTestStatusVars) => `/v1/admin/creators/${vars.id}/test-status`,
  buildBody: (vars: SetPartnerCreatorTestStatusVars) => ({ isTestCreator: vars.isTestCreator }),
  parseResponse: (raw: unknown): SetPartnerCreatorTestStatusResponse => raw as SetPartnerCreatorTestStatusResponse,
  optimistic: [{
    queryKey: ['admin', 'partner-creators'],
    apply: (prev: any, vars: SetPartnerCreatorTestStatusVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['admin', 'partner-creator'],
    apply: (prev: any, vars: SetPartnerCreatorTestStatusVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
